export const BOOKING_URL = "https://system.physica.no/book/actusosteopati";

export const CLINIC = {
  name: "Actus Osteopati",
  address: "Lilletorget 1",
  city: "0184 Oslo",
};

export const NAV_LINKS = [
  { label: "Våre tjenester", to: "/tjenester" },
  { label: "Priser", to: "/priser" },
  { label: "Om oss", to: "/om-oss" },
  { label: "Helseforsikring", to: "/helseforsikring" },
  { label: "Bedriftsbehandling", to: "/bedriftsbehandling" },
  { label: "Kontakt oss", to: "/kontakt" },
];

export const CONDITIONS = [
  "Ryggsmerter",
  "Nakkesmerter",
  "Hodepine",
  "Svimmelhet",
  "Skulderplager",
  "Hofte- og bekkensmerter",
  "Kneplager",
  "Fordøyelsesproblematikk",
  "Idrettsskader",
  "Stressrelaterte problemer",
];

export const THERAPISTS = [
  {
    name: "Elsa Ruz Rojas",
    initials: "ER",
    title: "Osteopat",
    photo: "/assets/therapist-elsa.jpg",
    bio: [
      "Elsa har vært aktiv med snowboard, fotball og løping, og har god forståelse for hvordan kroppen påvirkes av både trening og hverdagens belastninger. Hos Elsa skal du føle deg velkommen og komfortabel – hun setter av god tid til samtalen, fordi hun mener at en god behandling starter med å lytte og forstå.",
      "Elsa ser hele mennesket, ikke bare plagen. Gjennom behandling og veiledning ønsker hun å fremme bevegelse, mestring og trygghet i egen kropp, slik at du får verktøy til å ta vare på helsen din også etter timen. For henne er tillit og en god relasjon grunnlaget for et godt behandlingsforløp.",
    ],
    interests: [
      "Idrettsskader og idrettsrelaterte plager",
      "Hodepine",
      "Stressrelaterte plager",
      "Pust og pusteproblematikk",
    ],
    education: [
      "Videreutdanning i osteopati, Høyskolen Kristiania (2016)",
      "Bachelor i osteopati, Høyskolen Kristiania (2015)",
      "1 år fysioterapi, OsloMet (2012)",
    ],
  },
  {
    name: "Amalie Arntsen",
    initials: "AA",
    title: "Osteopat",
    photo: "/assets/therapist-amalie.jpg",
    bio: [
      "Amalie har bakgrunn som danser, personlig trener og gruppetreningsinstruktør. For Amalie er det viktig at pasienter føler seg trygge, sett og ivaretatt i behandling. Hun er opptatt av samspillet mellom den fysiske og psykiske helsen, og møter kroppen på en helhetlig måte.",
      "Siden 2018 har hun jobbet som personlig trener og har solid kompetanse innen trening og bevegelse. Hun veileder deg gjerne i trening tilpasset dine plager.",
    ],
    interests: [
      "Nakke- og stressrelaterte plager",
      "Mage- og fordøyelsesproblemer",
      "Pusteproblematikk",
      "Hofte- og bekkensmerter",
    ],
    education: [
      "Videreutdanning i osteopati, Høyskolen Kristiania (2023)",
      "Bachelor i osteopati, Høyskolen Kristiania (2022)",
      "Gruppetreningsinstruktør, Sats Academy (2018)",
      "Personlig trener og kostholdsveileder, Active Education (2018)",
    ],
  },
  {
    name: "Silje Kildahl",
    initials: "SK",
    title: "Osteopat",
    photo: "/assets/therapist-silje.jpg",
    bio: [
      "Silje har stor interesse for styrketrening og idrett, og har erfaring som osteopat for basketballandslaget. Hun har derfor et særlig engasjement for idrettsskader, belastningsplager og det å hjelpe mennesker tilbake til aktivitet – uansett alder eller forutsetninger. Hun er nysgjerrig på hvorfor plager oppstår, og ser på hvordan blant annet belastning, bevegelse, stress og hverdagen kan påvirke smerter og funksjon.",
      "I behandlingen kombinerer Silje manuelle teknikker med individuelt tilpassede øvelser og råd. Målet er at pasienten skal føle seg sett og forstått, og få både økt forståelse og strategier for veien videre.",
    ],
    interests: [
      "Idrettsskader",
      "Skulderproblematikk",
      "Akutte og langvarige ryggsmerter",
      "Nakke- og stressrelaterte plager",
      "Hodepine",
    ],
    education: [
      "Videreutdanning i osteopati, Høyskolen Kristiania (2025)",
      "Bachelor i osteopati, Høyskolen Kristiania (2022)",
    ],
  },
];

export const IMAGES = {
  hero: "/assets/hero.jpg",
  treatment: "/assets/treatment-foot.jpg",
  interior:
    "https://images.pexels.com/photos/7789616/pexels-photo-7789616.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const CONTACT = {
  phones: [
    { name: "Elsa Ruz Rojas", number: "+47 413 31 035" },
    { name: "Amalie Arntsen", number: "+47 468 51 484" },
    { name: "Silje Kildahl", number: "+47 902 34 841" },
  ],
  email: "post@actusosteopati.no",
};

export const HOURS = [
  ["Mandag", "08.00 – 19.00"],
  ["Tirsdag", "08.00 – 20.00"],
  ["Onsdag", "08.00 – 16.00"],
  ["Torsdag", "08.30 – 15.00"],
  ["Fredag", "08.00 – 18.30"],
  ["Lørdag", "Etter avtale"],
  ["Søndag", "Etter avtale"],
];

export const PRICES = [
  { name: "Førstegangskonsultasjon", duration: "60 min", price: "1 040,-" },
  { name: "Oppfølgende konsultasjon", duration: "45 min", price: "825,-" },
  { name: "Oppfølgende konsultasjon", duration: "30 min", price: "700,-" },
];
